import { render, staticRenderFns } from "./ForeignLanguagesFormComponent.vue?vue&type=template&id=3e54ef07&xmlns=true&"
import script from "./ForeignLanguagesFormComponent.vue?vue&type=script&lang=js&"
export * from "./ForeignLanguagesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports